/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casemanagement_Title1Inputs */

const en_settings_casemanagement_title1 = /** @type {(inputs: Settings_Casemanagement_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case Management`)
};

/**
* | output |
* | --- |
* | "Case Management" |
*
* @param {Settings_Casemanagement_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casemanagement_title1 = /** @type {((inputs?: Settings_Casemanagement_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casemanagement_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casemanagement_title1(inputs)
});
export { settings_casemanagement_title1 as "settings_caseManagement_title" }